<template><section><h2>玉玦图</h2>
<block-demo tip="" source="const data = [
  {
    type: &#39;政法干部&#39;,
    count: 6654
  },

  {
    type: &#39;平安志愿者&#39;,
    count: 5341
  },

  {
    type: &#39;人民调解员&#39;,
    count: 3546
  },

  {
    type: &#39;心理咨询师&#39;,
    count: 4321
  },

  {
    type: &#39;法律工作者&#39;,
    count: 3923
  },

  {
    type: &#39;网格员&#39;,
    count: 5345
  }
].sort((a, b) =&gt; a.count - b.count)

const { Chart, RadialBar, Legend, Tooltip } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;
})

chart.source(data, {
  row: &#39;type&#39;,
  text: &#39;type&#39;,
  value: &#39;count&#39;
})

const radialBar = new RadialBar({
  min: 0,
  max: 10000,
  radius: 0.6,
  innerRadius: 0.1,
  lineWidth: 10
})

radialBar.style(&#39;arc&#39;, { lineCap: &#39;round&#39; })

const legend = new Legend({
  orient: &#39;vertical&#39;,
  align: [&#39;right&#39;, &#39;center&#39;],
})

chart.append([radialBar, legend, new Tooltip()])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">type</span>: <span class="hljs-string">'政法干部'</span>,
    <span class="hljs-attr">count</span>: <span class="hljs-number">6654</span>
  },

  {
    <span class="hljs-attr">type</span>: <span class="hljs-string">'平安志愿者'</span>,
    <span class="hljs-attr">count</span>: <span class="hljs-number">5341</span>
  },

  {
    <span class="hljs-attr">type</span>: <span class="hljs-string">'人民调解员'</span>,
    <span class="hljs-attr">count</span>: <span class="hljs-number">3546</span>
  },

  {
    <span class="hljs-attr">type</span>: <span class="hljs-string">'心理咨询师'</span>,
    <span class="hljs-attr">count</span>: <span class="hljs-number">4321</span>
  },

  {
    <span class="hljs-attr">type</span>: <span class="hljs-string">'法律工作者'</span>,
    <span class="hljs-attr">count</span>: <span class="hljs-number">3923</span>
  },

  {
    <span class="hljs-attr">type</span>: <span class="hljs-string">'网格员'</span>,
    <span class="hljs-attr">count</span>: <span class="hljs-number">5345</span>
  }
].sort(<span class="hljs-function">(<span class="hljs-params">a, b</span>) =&gt;</span> a.count - b.count)

<span class="hljs-keyword">const</span> { Chart, RadialBar, Legend, Tooltip } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})

chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'type'</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">'type'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'count'</span>
})

<span class="hljs-keyword">const</span> radialBar = <span class="hljs-keyword">new</span> RadialBar({
  <span class="hljs-attr">min</span>: <span class="hljs-number">0</span>,
  <span class="hljs-attr">max</span>: <span class="hljs-number">10000</span>,
  <span class="hljs-attr">radius</span>: <span class="hljs-number">0.6</span>,
  <span class="hljs-attr">innerRadius</span>: <span class="hljs-number">0.1</span>,
  <span class="hljs-attr">lineWidth</span>: <span class="hljs-number">10</span>
})

radialBar.style(<span class="hljs-string">'arc'</span>, { <span class="hljs-attr">lineCap</span>: <span class="hljs-string">'round'</span> })

<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend({
  <span class="hljs-attr">orient</span>: <span class="hljs-string">'vertical'</span>,
  <span class="hljs-attr">align</span>: [<span class="hljs-string">'right'</span>, <span class="hljs-string">'center'</span>],
})

chart.append([radialBar, legend, <span class="hljs-keyword">new</span> Tooltip()])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>